import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserGroceryBaggerGame from 'src/games/GroceryBaggerGame/Main';

interface GroceryBaggerGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class GroceryBaggerGame extends React.Component<GroceryBaggerGameProps> {
    constructor(props: GroceryBaggerGameProps) {
        super(props);
        bindAllOfThis(this, GroceryBaggerGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserGroceryBaggerGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default GroceryBaggerGame;



// WEBPACK FOOTER //
// ./src/pages/game/GroceryBaggerGame.tsx